import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
import SearchPopup from './SearchPopup';
import Sidebar from './Sidebar';
import { ADMIN_PORTAL_BASE } from './portal';
import navLogo from "../../../assets/images/resources/logo-2.png";

const MOBILE_MENU_BODY_CLASS = "mobile-menu-visible";

const HeaderBar = ({ parentMenu, secondParentMenu, activeMenu, isMobileMenu, onToggleMenu, onSearch }) => (
    <nav className="main-menu">
        <div className="main-menu__wrapper">
            <div className="main-menu__wrapper-inner">
                <div className="main-menu__left">
                    <div className="main-menu__logo">
                        <Link to="/" aria-label="Mboapass — accueil">
                            <img src={navLogo} alt="Mboapass" />
                        </Link>
                    </div>
                </div>

                <div className="main-menu__right">
                    <div className="main-menu__main-menu-box">
                        <MenuItems
                            parentMenu={parentMenu}
                            secondParentMenu={secondParentMenu}
                            activeMenu={activeMenu}
                        />
                    </div>
                    <div className="main-menu__cart-search-nav-sidebar-icon-and-btn-box">
                        <button
                            type="button"
                            className="main-menu__search search-toggler"
                            onClick={onSearch}
                            aria-label="Rechercher un événement"
                        >
                            <span className="icon-loupe"></span>
                        </button>
                    </div>
                    <div className="main-menu__btn-box">
                        <a
                            href={`${ADMIN_PORTAL_BASE}/register`}
                            className="main-menu__btn thm-btn"
                            rel="noopener noreferrer"
                        >
                            Créer une billeterie
                        </a>
                    </div>
                    <div className="main-menu__btn-box">
                        <a
                            href={`${ADMIN_PORTAL_BASE}/login`}
                            className="main-menu__btn thm-btn-2"
                            rel="noopener noreferrer"
                        >
                            Connexion
                        </a>
                    </div>
                    <button
                        type="button"
                        className="mobile-nav__toggler mboa-header__burger"
                        onClick={onToggleMenu}
                        aria-label={isMobileMenu ? "Fermer le menu" : "Ouvrir le menu"}
                        aria-expanded={isMobileMenu}
                    >
                        <i className="fa fa-bars" />
                    </button>
                </div>
            </div>
        </div>
    </nav>
);

const Header = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileMenu, setMobileMenu] = useState(false);
    const [isPopup, setIsPopup] = useState(false);
    const [isSidebar, setIsSidebar] = useState(false);

    const handleMobileMenu = useCallback(() => setMobileMenu((open) => !open), []);
    const closeMobileMenu = useCallback(() => setMobileMenu(false), []);

    useEffect(() => {
        document.body.classList.toggle(MOBILE_MENU_BODY_CLASS, isMobileMenu);
        return () => document.body.classList.remove(MOBILE_MENU_BODY_CLASS);
    }, [isMobileMenu]);

    useEffect(() => {
        if (!isMobileMenu) return undefined;
        const onKey = (e) => {
            if (e.key === "Escape") closeMobileMenu();
        };
        const onResize = () => {
            if (window.innerWidth >= 1200) closeMobileMenu();
        };
        window.addEventListener("keydown", onKey);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("keydown", onKey);
            window.removeEventListener("resize", onResize);
        };
    }, [isMobileMenu, closeMobileMenu]);

    const handlePopup = () => {
        setIsPopup(!isPopup);
    }

    const handleSidebar = () => {
        setIsSidebar(!isSidebar);
    }

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 100);
        document.addEventListener("scroll", handleScroll, { passive: true });
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);

    const barProps = {
        parentMenu,
        secondParentMenu,
        activeMenu,
        isMobileMenu,
        onToggleMenu: handleMobileMenu,
        onSearch: handlePopup,
    };

    return (
        <React.Fragment>
            <header className={`main-header mboa-header ${isVisible ? "fixed-header" : ""}`}>
                <HeaderBar {...barProps} />
                <div className={`stricky-header stricked-menu main-menu mboa-header ${isVisible ? "stricky-fixed" : ""}`}>
                    <div className="sticky-header__content" />
                    <HeaderBar {...barProps} />
                </div>
                <MobileMenu handleMobileMenu={closeMobileMenu} onSearch={handlePopup} />
            </header>
            <div className="mboa-header__spacer" aria-hidden="true" />
            <SearchPopup isPopup={isPopup} handlePopup={handlePopup} />
            <Sidebar isSidebar={isSidebar} handleSidebar={handleSidebar} />
        </React.Fragment>
    );
}

export default Header;
